import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { CompletePetDetailsPetList } from './CompletePetDetailsPetList';

import styles from './CompletePetDetails.module.css';

const PetsRolledOverSection = ({
  getOriginalPetName = () => '',
  isPetDetailsComplete = () => false,
  isReplaced = () => false,
  onCancelReplacement = () => { },
  onConfirmReplacement = () => { },
  onReplaceSubmit = () => { },
  onUndoReplace = () => { },
  onUpdatePetDemographics = () => { },
  pets = [],
}) => {
  const { t } = useTranslation('petDemos');

  if (pets.length === 0) {
    return null;
  }

  return (
    <div className={styles.rolloverSection}>
      <h3 className={styles.rolloverSectionTitle}>
        {t('completeInformation.rolloverTitle')}
      </h3>

      <p className={styles.rolloverDescription}>
        <Trans
          components={{ bold: <span className={styles.subNoteBold} /> }}
          i18nKey="completeInformation.rolloverDescription"
          ns="petDemos"
        />
      </p>

      <CompletePetDetailsPetList
        getOriginalPetName={getOriginalPetName}
        isPetDetailsComplete={isPetDetailsComplete}
        isReplaced={isReplaced}
        isRolloverCard
        onCancelReplacement={onCancelReplacement}
        onConfirmReplacement={onConfirmReplacement}
        onReplaceSubmit={onReplaceSubmit}
        onUndoReplace={onUndoReplace}
        onUpdatePetDemographics={onUpdatePetDemographics}
        pets={pets}
      />
    </div>
  );
};

export { PetsRolledOverSection };
